// extracted by mini-css-extract-plugin
export default {"productGrid":"mZ-z","centerLink":"nZ-z","productSection":"oZ-z","item":"pZ-z","ctaButton":"qZ-z"};